import { useServiceConfigurationFormContext } from '../ServiceConfigurationForm';
import {
  CustomFormattedMessage,
  TranslationsKeys,
} from '../../../../../../i18n/i18n';
import {
  PaymentMethodState,
  useGetVehicleByIdV2Query,
} from '../../../../../../codegen/vehicles';
import {
  useLoadedVehicles,
  useSelectedVehicle,
} from '../../../../../../state/vehicles/useVehicles';
import { ServiceCardPanel } from './ServiceCardPanel';
import { useDispatch } from 'react-redux';
import {
  closeConfigurationDialog,
  openAddNewServiceCardDialog,
} from '../../../../state/onboardingUiSlice';
import { useEffect } from 'react';

const messageIdByState: Record<PaymentMethodState, TranslationsKeys> = {
  [PaymentMethodState.Active]: 'onboarding.dialog.firstCard.cardAddedMessage',
  [PaymentMethodState.OnboardingFailure]:
    'onboarding.dialog.firstCard.cardFailedMessage',
  [PaymentMethodState.OnboardingPending]:
    'onboarding.dialog.firstCard.cardPendingMessage',
};

export const FirstCardContent = () => {
  const { updateServiceActivations } = useLoadedVehicles();
  const dispatch = useDispatch();
  const formContext = useServiceConfigurationFormContext();
  const selectedVehicle = useSelectedVehicle();
  const formData = formContext.watch();
  const paymentMethod = formData.paymentMethods[0];

  const polledVehicleData = useGetVehicleByIdV2Query({
    vehicleId: selectedVehicle?.id || '',
  });

  useEffect(() => {
    if (polledVehicleData.data) {
      updateServiceActivations(
        polledVehicleData.data.id,
        polledVehicleData.data.serviceActivations,
      );
    }
  }, [polledVehicleData]);

  if (!paymentMethod) return null;

  return (
    <>
      <CustomFormattedMessage id={messageIdByState[paymentMethod.state]} />

      <ServiceCardPanel
        callbackAfterDelete={() => {
          dispatch(closeConfigurationDialog());
          dispatch(
            openAddNewServiceCardDialog({
              paymentPartnerType: paymentMethod.paymentPartner,
            }),
          );
        }}
        vehicleId={selectedVehicle!.id}
        paymentMethod={paymentMethod}
      />
    </>
  );
};
